import find from 'lodash/find';

export function getCurrentLocale(localeOptions, locale, defaultString) {
    let locales = localeOptions.asMutable ? localeOptions.asMutable() : localeOptions;
    if (!Array.isArray(locales)) {
        console.error('Locale options will not render correctly! Expecting an array of objects containing both [name] and [lang] keys!');
        locales = [];
    }

    let currentLocale = defaultString;
    const activeLocal = find(locales, { lang: locale });
    if (locale && activeLocal) {
        currentLocale = activeLocal.name;
    }

    return { currentLocale, locales };
}



/** WEBPACK FOOTER **
 ** ./app/scripts/utils/localeUtils.js
 **/